(() => {
    let doc = document.documentElement;

    /**
     * Implement a safety mechanism which disables the sticky header if it takes up too large a
     * portion of vertical screen space.
     */
    doc.addEventListener('header-measured', (e) => {
        const threshold = 0.22;
        const headerCoverage = H_Tools?.header?.height / window.innerHeight;
        const isTooLarge = headerCoverage > threshold;

        doc.classList.toggle('-sticky-header-disabled', isTooLarge);
        doc.classList.toggle('-sticky-header-enabled', !isTooLarge);
    });

    /**
     * Make focusable elements backwards focusable at page load.
     */
    H_Tools?.stickyheader?.makeBackwardsFocusable(
        document.querySelector('.js-site-supplementary'),
        document.querySelector('.js-site-main'),
        document.querySelector('.js-site-footer')
    );
})();
